import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminDockerInstances = {
  dockerInstances: {
    pageTitle: "インスタンス管理",
    pageSubtitle: "コンテナインスタンスの作成、コンソール、イメージ固化",
    objects: {
      instance: "インスタンス",
    },
    summary: {
      total: "インスタンス総数：{count}",
      running: "実行中：{count}",
      stopped: "停止済み：{count}",
      withWebEndpoint: "Web 入口あり：{count}",
    },
    table: {
      name: commonShortFieldLabels.name,
      kind: "インスタンスタイプ",
      image: "イメージ識別子",
      status: commonShortNouns.status,
      webEndpoint: "Web 入口",
      portMapping: "ポートマッピング",
      expiresAt: "有効期限",
      createdAt: commonShortFieldLabels.createdAt,
      actions: "操作",
    },
    dialogs: {
      commitTitle: "インスタンスからイメージを生成",
    },
    form: {
      imageName: "イメージ識別子",
      imageNameRequired: "イメージ識別子を入力してください",
      imageNamePlaceholder: "例：exam/practical-upload:snapshot-001",
      description: "説明",
      descriptionPlaceholder: "イメージ説明",
      tags: "タグ（カンマ区切り）",
      tagsPlaceholder: "例：v1.1,practical,web",
    },
    actions: {
      confirm: "確認",
      detailConsole: "詳細 / コンソール",
      start: "起動",
      stop: "停止",
      commitImage: "イメージ生成",
    },
    confirmDelete: {
      title: "このインスタンスを削除しますか？",
    },
    messages: {
      started: "インスタンスを起動しました",
      stopped: "インスタンスを停止しました",
      deleted: "インスタンスを削除しました",
      imageCommitted: "イメージを生成しました：{name}",
      defaultCommitDescription: "from container {containerId}",
    },
  },
  dockerInstanceCreate: {
    title: "インスタンス作成",
    imagePickerTitle: "イメージを選択（名前 / 識別子）",
    table: {
      image: "イメージ識別子",
      declaredPorts: "宣言ポート",
      effectivePorts: "有効ポート",
      description: "説明",
      actions: "操作",
    },
    form: {
      kind: "インスタンスタイプ",
      kindRequired: "インスタンスタイプを選択してください",
      kindWeb: "Web（ポートマッピング）",
      kindGeneric: "Generic（ポートマッピングなし）",
      name: "インスタンス名",
      namePlaceholder: "任意、デフォルトで自動生成",
      image: "イメージ識別子",
      imageRequired: "イメージ識別子を選択してください",
      imagePlaceholder: "イメージ名またはイメージ識別子で検索",
      chooseFromList: "イメージ名 / 識別子一覧から選択",
      chooseImageHint: "ダイアログでイメージ名または識別子を絞り込み、イメージ識別子を入力できます",
      containerPort: "コンテナ内部ポート",
      containerPortRequired: "コンテナ内部ポートを入力してください",
      containerPortHint:
        "web タイプでのみ有効：ホスト側のランダムポートへマッピングされます（`host_port:container_port`）。host ポートを手動指定するものではありません。",
      ttlMinutes: "有効期限（分）",
      ttlRequired: "TTL を入力してください",
      inputMode: "パラメータ入力方式",
      inputModeForm: "フォームモード",
      inputModeJson: "構造化パラメータモード",
      paramsJson: "構造化パラメータ",
      cpuLimit: "CPU 上限（コア）",
      memoryLimit: "メモリ上限（MB）",
      consoleInteraction: "コンソール操作",
      tty: "端末モード (-t)",
      stdinOpen: "標準入力 (-i)",
      envVars: "環境変数",
      addEnvVar: "環境変数を追加",
      envKeyRequired: "変数名を入力してください",
      envKeyPlaceholder: "変数名（例：NODE_ENV）",
      envValuePlaceholder: "変数値（例：production）",
      entrypointArgs: "エントリポイント引数",
      addEntrypointArg: "エントリポイント引数を追加",
      arg: "引数",
      entrypointArgPlaceholder: "最初の項目はエントリポイントコマンド、その後は引数です",
      commandArgs: "コマンド引数",
      addCommandArg: "コマンド引数を追加",
      commandArgPlaceholder: "順番どおりにコマンド引数を渡します",
      imageKeywordPlaceholder: "イメージ名またはイメージ識別子を入力して絞り込み",
      selectImage: "選択",
    },
    messages: {
      jsonMustBeObject: "JSON パラメータはオブジェクトである必要があります",
      jsonInvalid: "JSON 形式が正しくありません",
      createSuccess: "インスタンスを作成しました",
    },
  },
  dockerInstanceDetail: {
    pageTitle: "インスタンス詳細",
    notFound: "該当するインスタンスが見つかりません。",
    sections: {
      basicInfo: "基本情報",
      callbackInfo: "callback 情報",
      runtimeData: "ランタイムデータ",
      webConsole: "Web コンソール",
    },
    fields: {
      name: commonShortFieldLabels.name,
      status: commonShortNouns.status,
      containerId: "コンテナ ID",
      image: "イメージ識別子",
      kind: "タイプ",
      webEndpoint: "Web 入口",
      hostPort: "ホストポート",
      containerPort: "コンテナポート",
      checkMode: "チェックモード",
      ttyStdin: "端末モード / 標準入力",
      createdAt: commonShortFieldLabels.createdAt,
      updatedAt: commonShortFieldLabels.updatedAt,
      expiresAt: "有効期限",
      mode: "モード",
      scriptPath: "スクリプトパス",
      callbackUrl: "コールバック URL",
      callbackToken: "コールバックトークン",
    },
    console: {
      description:
        "コンテナ内で実行する Shell コマンドを入力します（`docker exec -i` ベースで、端末モードが有効な場合は `-t` も付与されます）。",
      placeholder: "例：id && pwd && ls -la",
      runCommand: "コマンドを実行",
      clearOutput: "出力をクリア",
      outputPlaceholder: "コマンド出力がここに表示されます",
    },
    actions: {
      copyUrl: "URL をコピー",
      copyToken: "トークンをコピー",
    },
    messages: {
      execCompleted: "実行完了：{status}",
      emptyValue: "{label} は空です",
      copySuccess: "{label} をコピーしました",
      copyFailed: "{label} のコピーに失敗しました",
    },
  },
} as const;
